import React, { useState } from 'react';
import Select from 'react-select';
import styles from './ModalSelector.module.css';
import ChevronIcon from '../icons/chevronIcon';

const ModalPickerSelector = ({
  title = '',
  options = [],
  selectedValue = null,
  onChange,
  formatOptionLabel,
  isSearchable = false,
}) => {
  const [modalOpened, setModalOpened] = useState(false);
  const [showOverlay, setShowOverlay] = useState(false);

  const handleChange = (option) => {
    onChange?.(option);
    closeModal();
  };

  const openModal = () => {
    setModalOpened(true);
    setShowOverlay(true);
    document.body.classList.add('overflow-hidden');
  };

  const closeModal = () => {
    setModalOpened(false);
    setTimeout(() => setShowOverlay(false), 300);
    document.body.classList.remove('overflow-hidden');
  };

  const customStyles = {
    control: (provided) => ({
      ...provided,
      backgroundColor: '#2f2f2f',
      borderColor: '#444',
      boxShadow: 'none',
      minHeight: '38px',
      '&:hover': { borderColor: '#666' },
    }),
    singleValue: (provided) => ({
      ...provided,
      color: 'var(--color-lighter-gray)',
    }),

    menu: (provided) => ({
      ...provided,
      backgroundColor: '#2f2f2f',
      borderRadius: '6px',
      marginTop: 4,
    }),
    menuList: (provided) => ({
      ...provided,
      maxHeight: 230,
      overflowY: 'auto',
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected
        ? 'var(--color-grey)'
        : state.isFocused
        ? 'var(--color-grey)'
        : 'transparent',
      color: 'var(--color-lighter-gray)',
      padding: '8px 12px',
      cursor: 'pointer',
      ':active': {
        backgroundColor: state.isSelected ? 'var(--color-grey)' : 'var(--color-grey)',
      },
    }),

    indicatorSeparator: () => ({ display: 'none' }),
  };

  return (
    <>
      <button className={styles.btnSelect} onClick={openModal}>
        {selectedValue?.value}
        <span>
          <ChevronIcon size={18} fillColor='var(--color-primary)' rotation={90} />
        </span>
      </button>

      {showOverlay && (
        <div
          className={`${styles.overlay} ${modalOpened ? styles.overlayVisible : ''}`}
          onClick={closeModal}
        />
      )}

      <div className={`${styles.modalPicker} ${modalOpened ? styles.modalPickerOpened : ''}`}>
        <div className={`${styles.modalTitle} mb-2 semi-bold`}>{title}</div>
        <Select
          value={selectedValue}
          onChange={handleChange}
          options={options}
          className='modal-selector'
          isSearchable={isSearchable}
          formatOptionLabel={formatOptionLabel}
          styles={customStyles}
        />
        <div className='close-page' onClick={closeModal}>
          <div className='mdiv'>
            <div className='md'></div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ModalPickerSelector;
